/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseOfString } from '../../models/api-response-of-string';

export interface UserResetAllPassword$Params {
  userIDs?: string | null;
  Password?: string | null;
  key?: string | null;
}

export function userResetAllPassword(http: HttpClient, rootUrl: string, params?: UserResetAllPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOfString>> {
  const rb = new RequestBuilder(rootUrl, userResetAllPassword.PATH, 'get');
  if (params) {
    rb.query('userIDs', params.userIDs, {});
    rb.query('Password', params.Password, {});
    rb.query('key', params.key, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseOfString>;
    })
  );
}

userResetAllPassword.PATH = '/user/resetallpassword';
